import { PickupAbility, PickupConfig } from "../GameConfig/PickupConfig.js";
import Pickup from "./pickup.js";

export default class Turret extends Pickup {
  constructor() {
    super();

    this.image.src = PickupConfig.Turret.IMG_SRC;
    this.spriteWidth = PickupConfig.Turret.SPRITE_WIDTH;
    this.spriteHeight = PickupConfig.Turret.SPRITE_HEIGHT;

    this.totalTime = PickupConfig.Turret.TOTAL_TIME_MS;

    this.ability = PickupAbility.TURRET;
  }
  enter(player) {
    player.ability.add(PickupAbility.TURRET);
  }
}
